(function () {
  const ROOT = '.ts-lg-pdp-new .product-single__meta';
  const mobile = window.matchMedia('(max-width: 768px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function slideStep(slides) {
    if (slides.length > 1) {
      const step = slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      if (step > 0) return step;
    }
    return slides[0].getBoundingClientRect().width || 1;
  }

  function updateActive(wrapper, dots) {
    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (!slides.length) return;
    const idx = Math.min(Math.round(wrapper.scrollLeft / slideStep(slides)), slides.length - 1);
    Array.from(dots.children).forEach(function (dot, i) {
      const active = i === idx;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function syncDots(container) {
    const wrapper = container.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    const slides = wrapper.querySelectorAll('.swiper-slide');
    let dots = container.querySelector('.ts-lg-nosto-dots');

    if (!mobile.matches || slides.length < 2) {
      if (dots) dots.remove();
      return;
    }

    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'ts-lg-nosto-dots';
      container.appendChild(dots);
    }

    if (dots.children.length !== slides.length) {
      dots.textContent = '';
      slides.forEach(function (slide, i) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ts-lg-nosto-dot';
        dot.setAttribute('aria-label', 'Empfehlung ' + (i + 1));
        dot.addEventListener('click', function () {
          const target = container.querySelectorAll('.swiper-slide')[i];
          if (target) {
            target.scrollIntoView({
              behavior: reduceMotion.matches ? 'auto' : 'smooth',
              inline: 'start',
              block: 'nearest'
            });
          }
        });
        dots.appendChild(dot);
      });
    }

    updateActive(wrapper, dots);
  }

  function initContainer(container) {
    const wrapper = container.querySelector('.swiper-wrapper');
    if (wrapper && !wrapper.dataset.tsSlider) {
      wrapper.dataset.tsSlider = '1';
      let raf;
      wrapper.addEventListener(
        'scroll',
        function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            const dots = container.querySelector('.ts-lg-nosto-dots');
            if (dots) updateActive(wrapper, dots);
          });
        },
        { passive: true }
      );
    }
    syncDots(container);
  }

  let scanRaf;
  function scan() {
    cancelAnimationFrame(scanRaf);
    scanRaf = requestAnimationFrame(function () {
      document.querySelectorAll(ROOT + ' .nosto-swiper-container').forEach(initContainer);
    });
  }

  function init() {
    const root = document.querySelector(ROOT);
    if (root) new MutationObserver(scan).observe(root, { childList: true, subtree: true });
    window.addEventListener('resize', scan);
    mobile.addEventListener('change', scan);
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
